export default {
  page_header: {
    title: "About",
    description: "An overview of the portal, its features, and current version.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Overview",
      title: "{laboratoryName} Portal",
      subtitle: "Online access to lab results, samples, and payments.",
      description:
        "{laboratoryName} gives patients and clinical staff a single, secure place to access results, track samples, and manage payments — from any device, in any of three languages.",

      version_info: {
        header: "Version Information:",
        frontend: "Frontend Version: 0.3.3",
        backend: "Backend Version: 0.0.1",
      },

      features: {
        header: "Features and capabilities:",

        sample_management: {
          title: "Sample Management",
          subtitle: "Full tracking from collection through to the final result.",
        },
        real_time_results: {
          title: "Real-Time Results",
          subtitle: "Real-time synchronization with laboratory instruments.",
        },
        multilingual_support: {
          title: "Multilingual Support",
          subtitle: "Easy switching between English, Bulgarian, and Macedonian.",
        },
        secure_authentication: {
          title: "Secure Authentication",
          subtitle: "Secure login via Keycloak — credentials always protected.",
        },
        responsive_design: {
          title: "Responsive Design",
          subtitle: "Full support for desktop, tablet, and phone.",
        },
        accessibility: {
          title: "Accessibility",
          subtitle: "Compliance with WCAG 2.1 AA accessibility standards.",
        },
        high_performance: {
          title: "High Performance",
          subtitle: "Fast loading even with large result sets.",
        },
      },

      targetUsers: {
        header: "Portal users:",

        otp_patients: {
          title: "OTP Patients",
          subtitle: "Online access to lab results and account balance.",
        },
        lab_technicians: {
          title: "Lab Technicians",
          subtitle: "Processing and verification of incoming samples.",
        },
        pathologists: {
          title: "Pathologists and Specialists",
          subtitle: "Review and validation of results across departments.",
        },
        lab_administrators: {
          title: "Lab Administrators",
          subtitle: "Monitoring of workloads, users, and daily operations.",
        },
      },
    },

    services_tab: {
      name: "Services",
      title: "LIS Portal Services",
      subtitle: "Self-service web portal for laboratory results and payments",

      refresh_button: "Refresh Services",
      refreshTooltip: "Refresh services",
      openApp: "Open application",
      openApiDocs: "OpenAPI documentation",
      healthCheck: "Health check endpoint",
    },

    actions_tab: {
      name: "Actions",
      title: "Portal Actions",
      subtitle: "Manage system cache and configurations",

      cache_card: {
        title: "Refresh Core Cache",
        content: "Refresh the server-side cache to force a refresh of all data from the database.",
        action: "Refresh Cache",
      },
    },

    copyright_tab: {
      name: "Copyright",
      title: "Copyright",
      subtitle: "Intellectual property and licenses",

      description_start: "All intellectual property of this application belongs to ",
      company_name: "SKYWARE Group",
      description_end:
        ". The rights to the components and libraries used in this application belong to their authors and are appropriately licensed as described below.",
    },

    credits_tab: {
      name: "Credits",
      title: "Credits",
      subtitle: "Built with open-source technologies",

      application_title: "Lab Portal",
      authors_of_application: "Authors of this application",
      licence: "license",
      et_al: "et al",
    },
  },
};
